import { action } from 'mobx';
import Collection from '~/glm/models/collection';
import GdsApi from '~/glm/utils/gds-api';

class GuestCollection extends Collection {
  @action
  deleteGuests = (guests = [], analyticsStore = {}, trackingProperties = {}) =>
    new Promise((resolve, reject) => {
      if (guests.length === 1 && Object.keys(trackingProperties).length > 0) {
        analyticsStore.track('Guest Deleted', trackingProperties);
      }

      const guestIds = guests.map(guest => guest.id);

      GdsApi.delete('/v1/people/bulk', guestIds)
        .then(() => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
}

export default GuestCollection;
